<h1 mat-dialog-title>Please Wait</h1>
<mat-dialog-content>Loading...</mat-dialog-content>